import { useLocation } from 'react-router-dom';
import { IFrameAppShell } from './IFrameAppShell';

interface IFrameAppShellWrapperProps {
  defaultUrl: string;
  title: string;
}

/**
 * Wrapper component that resolves iframe URL from location.state or falls back to default.
 * This keeps IFrameAppShell pure and testable without React Router dependencies.
 *
 * The wrapper:
 * - Reads deep link URL from React Router's location.state (if present)
 * - Validates the URL format
 * - Falls back to defaultUrl if state is missing or invalid
 * - Passes the resolved URL to IFrameAppShell as a simple prop
 */
export function IFrameAppShellWrapper({ defaultUrl, title }: IFrameAppShellWrapperProps) {
  const location = useLocation();
  const state = location.state as { iframeUrl?: string } | null;
  const deepLinkUrl = state?.iframeUrl;

  // Validate deep link URL if present
  const isValidDeepLink = deepLinkUrl
    ? (() => {
        try {
          new URL(deepLinkUrl);
          return true;
        } catch {
          return false;
        }
      })()
    : false;

  // Use deep link if valid, otherwise fall back to default
  const resolvedUrl = isValidDeepLink && deepLinkUrl ? deepLinkUrl : defaultUrl;

  return <IFrameAppShell iframeUrl={resolvedUrl} title={title} />;
}
